enum FootTrafficReportType {
  ImpressionsReports = 'FOOT_TRAFFIC_IMPRESSIONS_REPORT',
  VisitsReports = 'FOOT_TRAFFIC_VISITS_REPORT',
}

export default FootTrafficReportType;
